import qs from 'qs';
import moment from 'moment';
import numeral from 'numeral';
import Blazy from 'blazy';

const CONFIG = {
  date: {
    iso: 'YYYY-MM-DD HH:mm:ss',
  },
};

export default {
  computed: {
    apiBaseUrl() {
      return this.$store.state.apiBaseUrl;
    },

    config() {
      return this.$store.state.config;
    },

    token() {
      return this.$store.state.token;
    },

    user() {
      return this.parseJwt(this.token);
    },
  },

  methods: {
    isVideo(url) {
      const videoExtensions = this.videoExtensions.some(ext => url.toLowerCase().endsWith(ext));
      return videoExtensions;
    },
    capitalizeFirstLetter(string) {
      if (!string) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    parseTextintoTitle(string) {
      if (!string) return '';
      string = string.replace('_', ' ');

      const result = [];
      const letters = string.split(' ');
      letters.forEach((value) => {
        result.push(this.capitalizeFirstLetter(value));
      });

      return result.join(' ');
    },

    toSlug(string) {
      if (!string) return '';
      return string.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-');
    },

    digitGrouping(string) {
      if (!string) return '';
      return numeral(string).format('0,0');
    },

    parseJwt(token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      return JSON.parse(window.atob(base64));
    },

    validateBearer() {
      const localToken = window.localStorage.getItem('token');
      const storeToken = this.$store.state.token;
      const axiosBearer = this.axios.defaults.headers.common.Authorization;
      const axiosToken = axiosBearer.split('Bearer ').pop().trim();

      if (axiosToken.length < 12) {
        if (!localToken) {
          if (window.localStorage.getItem('reload') === 1) {
            this.$swal({
              title: 'Auth Required',
              text: 'Authorization missing, please relogin.',
              type: 'warning',
              timer: 8000,
              onClose: () => {
                this.$store.commit('REMOVE_TOKEN');
                this.$store.commit('REMOVE_USER');

                if (window.localStorage) {
                  window.localStorage.removeItem('token');
                }

                this.$router.push('/login');
              },
            });
          }

          window.localStorage.setItem('reload', 1);
          location.reload();
          return;
        }

        if (storeToken !== localToken) {
          this.$store.commit('SET_TOKEN', localToken);
        }

        this.axios.defaults.headers.common.Authorization = `Bearer ${storeToken}`;
        window.localStorage.removeItem('reload');
      }
    },

    stringify(data) {
      if (!data) return '';
      return qs.stringify(data);
    },

    parseTime(date, format) {
      if (!date) return '';

      const formatTo = format || CONFIG.date.iso;
      return moment(date).format(formatTo);
    },

    parseImage(url, size) {
      if (!url) return '';

      const imageSize = size || '_thumb';
      return url.substring(0, url.lastIndexOf('.')) + imageSize + url.substring(url.lastIndexOf('.'));
    },

    getSize(url, size) {
      if (!url) return '';
      const imageSize = (size) ? `_${size}` : '';
      return url.replace(/(\.[\w\d_-]+)$/i, `${imageSize}$1`);
    },

    numberFormat(number) {
      const reverse = number.toString().split('').reverse().join('');

      let result = reverse.match(/\d{1,3}/g);
      result = result.join('.').split('').reverse().join('');

      return result;
    },

    initLazyLoad() {
      // eslint-disable-next-line no-new, no-unused-vars
      belazy = new Blazy({
        selector: '.thumbnail',
      });
    },

    revalidateLazyload() {
      if (typeof belazy !== 'undefined') {
        belazy.revalidate();
      }
    },
  },

  mounted() {
    this.validateBearer();
  },
};



// WEBPACK FOOTER //
// ./src/mixins/Common.js